import React from 'react'
import { formValues } from 'redux-form'
import { FiAlertCircle } from 'react-icons/fi'
import { withTranslation } from 'react-i18next'
import Tooltip from '../../../../components/Tooltip/Tooltip'
import { PriceInputWithCurrency } from './index'

function afterIcon(title: string, size) {
  return (
    <Tooltip
      size={size}
      whiteSpace={false}
      disableHoverListener={true}
      title={title}
      tooltipId={title}
      placement={'top'}
    >
      <FiAlertCircle size={18 * size} />
    </Tooltip>
  )
}

const PriceInputWithToolTip = ({ priceType, t, size, name, ...rest }: any) => {
  return (
    <PriceInputWithCurrency
      size={size}
      name={name}
      {...rest}
      withAfterIcon={
        Number(priceType) === 1 && name === 'pricePerDay'
          ? afterIcon(
              t('reservation_price_dialog_content_per_day')
                .replace(/\\n/g, '\n')
                .replace(/\\n/g, '\r'),
              size,
            )
          : Number(priceType) === 3 && name === 'pricePerPerson'
          ? afterIcon(
              t('BED_2587_reservation_price_dialog_content_per_person')
                .replace(/\\n/g, '\n')
                .replace(/\\n/g, '\r'),
              size,
            )
          : null
      }
    />
  )
}

export default formValues<any>('priceType')(
  withTranslation()(PriceInputWithToolTip),
)
